export const iconFontAwesomeHumanitarianPersonFallingBurst = (
	<i className="fa-solid fa-person-falling-burst"></i>
);
